import { createFileRoute } from '@tanstack/react-router';
import { UiPreview } from '../app/ui-preview';

/** Design system preview (non-production builds only). */
export const Route = createFileRoute('/dev/ui')({ component: UiPreview });
